<script setup lang="ts">

import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth.store'
import { useLeadsStore } from '@/stores/leads.store'
import { 
  LayoutDashboard, 
  BookOpen, 
  Search, 
  Users,
  FolderOpen,
  Settings,
  LogOut 
} from 'lucide-vue-next'


const auth = useAuthStore()
const leadsStore = useLeadsStore()


const menuGroups = [
  {
    title: 'HOME',
    items: [
      { name: 'Dashboard', icon: LayoutDashboard, route: 'dashboard' }
    ]
  },
  {
    title: 'LEAD MANAGEMENT',
    items: [
      { name: 'Contact Directory', icon: BookOpen, route: 'contact' },
      { name: 'Leads', icon: Search, route: 'leads' },
      { name: 'Sales Pipeline', icon: Search, route: 'sales-pipeline' }
    ]
  },
  {
    title: 'HR & CLIENTS',
    items: [
      { name: 'Clients', icon: Users, route: 'clients' },
      { name: 'Projects', icon: FolderOpen, route: 'projects' }
    ]
  },
  {
    title: 'SYSTEM SETUP',
    items: [
      {
        name: 'System Settings',
        icon: Settings,
        route: 'settings'
      }
    ]
  }
]
</script>

<template>
  <aside class="w-[280px] h-screen bg-white border-r border-slate-100 flex flex-col justify-between p-6 font-['Plus_Jakarta_Sans',sans-serif] select-none">
    
    <div>
      <div class="flex items-center gap-3.5 px-2 mb-8">
        <div class="h-12 w-12 rounded-2xl bg-[#2884EF] flex items-center justify-center shadow-lg shadow-blue-500/20">
          <span class="text-white text-xl font-black tracking-tighter">e</span>
        </div>
        <div>
          <div class="flex items-center gap-2">
            <h2 class="text-lg font-bold text-slate-900 tracking-tight leading-none">Empleo-CRM</h2>
            <span class="text-[9px] font-bold uppercase tracking-wider text-slate-400 bg-slate-50 border border-slate-200/60 px-1.5 py-0.5 rounded-md">Sandbox</span>
          </div>
          <p class="text-[10px] font-bold tracking-widest text-slate-400 uppercase mt-1">AyahTek Solutions</p>
        </div>
      </div>

      <nav class="space-y-6">
        <div v-for="group in menuGroups" :key="group.title" class="space-y-1">
          <span class="text-[10px] font-extrabold tracking-wider text-slate-400 block px-3 py-1 mb-1.5">{{ group.title }}</span>
          
          <RouterLink
            v-for="item in group.items"
            :key="item.name"
            :to="{ name: item.route }"
            v-slot="{ isActive }"
          >
            <div
              :class="[
                'sidebar-nav-button w-full flex items-center gap-3.5 px-4 py-3 rounded-xl font-bold tracking-tight transition-all duration-200 group cursor-pointer relative',
                isActive 
                  ? 'bg-[#2884EF] text-white shadow-md shadow-blue-500/10' 
                  : 'text-slate-500 hover:text-slate-900 hover:bg-slate-50/80'
              ]"
            >
              <component 
                :is="item.icon" 
                :class="[
                  'h-[18px] w-[18px] transition-transform duration-200',
                  isActive ? 'text-white' : 'text-slate-400 group-hover:text-slate-700'
                ]" 
              />
              <span>{{ item.name }}</span>
            </div>
          </RouterLink>
        </div>
      </nav>
    </div>

    <div class="space-y-4">
        <div class="bg-slate-50/60 border border-slate-100/80 rounded-2xl p-4 flex items-center gap-3">
        <div class="h-10 w-10 rounded-full bg-[#2884EF] flex items-center justify-center font-bold text-xs text-white uppercase">
            {{ auth.user?.name ? auth.user.name.charAt(0) : 'e' }}
        </div>
        <div class="leading-none">
            <h4 class="text-xs font-bold text-slate-900 tracking-tight mb-1">
            {{ auth.user?.name }}
            </h4>
            <span class="text-[9px] font-bold tracking-wider uppercase text-slate-400">
             Owner
            </span>
        </div>
        </div>

        <button 
        @click="auth.logout()"
        class="sidebar-nav-button w-full flex items-center gap-3.5 px-4 py-3 font-bold text-slate-400 hover:text-rose-600 hover:bg-rose-50/60 rounded-xl transition-all duration-150 cursor-pointer group"
        >
        <LogOut class="h-[18px] w-[18px] text-slate-400 group-hover:text-rose-500 transition-colors" />
        <span>Logout</span>
        </button>

    </div>


  </aside>
</template>
